import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getAgencies: async (params) => await apiClient.get(endpoints.getAll(), { params }),
  getAgencyById: async (id) => await apiClient.get(endpoints.getById(id)),
  getUsersByAgencyId: async ({ id, params }) => await apiClient.get(endpoints.getUsersByAgencyId(id), { params }),
  getAgencyIdentifiers: async (id, params) => await apiClient.get(endpoints.getAgencyIdentifiers(id), { params }),
  createAgencyUser: async (params) => await apiClient.post(endpoints.createAgencyUser(), params),
  createAgency: async (params) => await apiClient.post(endpoints.createAgency(), params),
  createAgencyUserResetLink: async (params) => await apiClient.post(endpoints.createAgencyUserResetLink(), params),
  sendInvitation: async (params) => await apiClient.post(endpoints.sendInvitationEmail(params), params),
};
